/**
 *
 * @module entry
 * @desc {SDK.Content.Bookmarks} entry point.
 *
 */

import BookmarkExtensions from './bookmarkExtensions';
import BookmarksQuery from './bookmarksQuery';

/**
 *
 * @typedef SDK.Content.Bookmarks
 * @type {Object}
 *
 * @property {Function} BookmarkExtensions
 * @property {BookmarksQuery} BookmarksQuery
 *
 */

/**
 *
 * @type {SDK.Content.Bookmarks}
 *
 */
export default {

    BookmarkExtensions,
    BookmarksQuery

};



// WEBPACK FOOTER //
// ./src/content/bookmarks/entry.js